
import dayjs from "dayjs";
import React from "react";
import useMainPage from "../MainPage/useMainPage";
import { IonIcon } from "@ionic/react";
import { personOutline } from "ionicons/icons";
import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Typography, Box, Card, Button } from "@mui/joy";

const MisDatos = () => {
  // Reutilizar el hook de MainPage para obtener datos y handlers

  const {
    paciente,
    nombre, apellido, correo, fechaNac, celular, nroDocumento,
    tiposDoc = [], mutuales = [], mutualAfiliado, tipoDoc, mutual,
    error,
    handleFechaChange, setCelular, setCorreo,
  } = useMainPage();

  // Estados y handlers locales para edición, igual que en MainPage
  const [editandoPerfil, setEditandoPerfil] = React.useState(false);

  const handleEditarPerfil = () => setEditandoPerfil(true);
  const handleCancelarEdicionPerfil = () => {
    setEditandoPerfil(false);
    // Restaurar valores originales del paciente
    if (paciente) {
      // Si tienes setters para los campos, restáuralos aquí si es necesario
      // Por simplicidad, se asume que los campos se sincronizan automáticamente
    }
  };
  // Guardar perfil: aquí deberías llamar a la función de guardar del formulario real
  const handleGuardarPerfil = async () => {
    // Aquí deberías llamar a la función de guardar del formulario real
    setEditandoPerfil(false);
  };

  return (
    <div className="tech-perfil-container" style={{ maxWidth: '1100px', margin: '24px auto' }}>
      <Card className="tech-section">
        <AccordionGroup className="tech-accordion">
          <Accordion defaultExpanded={true}>
            <AccordionSummary>
              <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                <Box display="flex" alignItems="center" gap={2}>
                  <div className="tech-action-icon" style={{ width: '40px', height: '40px', fontSize: '18px', background: 'var(--gradient-secondary)' }}>
                    <IonIcon icon={personOutline} />
                  </div>
                  <div>
                    <Typography level="title-sm" className="tech-prestador-title">
                      Mi perfil
                    </Typography>
                    <Typography level="body-xs" className="tech-prestador-subtitle">
                      Información personal
                    </Typography>
                  </div>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Card className="tech-interactive" sx={{ background: 'rgba(102, 126, 234, 0.05) !important', border: '1px solid rgba(102, 126, 234, 0.1) !important', borderRadius: 'var(--radius-md) !important', padding: 'var(--spacing-md) !important' }}>
                <Box display="flex" flexDirection="column" gap={2}>
                  {/* Campos no editables - Solo lectura */}
                  <Box display="flex" gap={2}>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Nombre:</Typography>
                      <Typography level="body-sm" sx={{ color: '#666' }}>{nombre || paciente?.nombre || '-'}</Typography>
                    </Box>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Apellido:</Typography>
                      <Typography level="body-sm" sx={{ color: '#666' }}>{apellido || paciente?.apellido || '-'}</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Tipo de documento:</Typography>
                      <Typography level="body-sm" sx={{ color: '#666' }}>
                        {(Array.isArray(tiposDoc) ? tiposDoc : []).find(doc => doc.codigo === tipoDoc)?.nombre || paciente?.documentoTipoNombre || '-'}
                      </Typography>
                    </Box>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Nro de documento:</Typography>
                      <Typography level="body-sm" sx={{ color: '#666' }}>{nroDocumento || paciente?.documentoNro || '-'}</Typography>
                    </Box>
                  </Box>
                  <Box display="flex" gap={2}>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Fecha de nacimiento:</Typography>
                      <input
                        type="text"
                        value={fechaNac || (paciente?.nacimiento ? dayjs(paciente.nacimiento).format('DD/MM/YYYY') : '')}
                        onChange={handleFechaChange}
                        disabled={!editandoPerfil}
                        placeholder="dd/mm/yyyy"
                        maxLength={10}
                        style={{ width: '100%', padding: '8px', borderRadius: '6px', border: error ? '1px solid red' : '1px solid #ccc', background: editandoPerfil ? 'white' : '#f5f5f5', cursor: editandoPerfil ? 'text' : 'not-allowed' }}
                      />
                      {error && <Typography level="body-xs" sx={{ color: 'red', mt: 0.5 }}>Formato inválido (dd/mm/yyyy)</Typography>}
                    </Box>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Celular:</Typography>
                      <input
                        type="text"
                        value={celular || paciente?.celular || ''}
                        onChange={e => setCelular(e.target.value)}
                        disabled={!editandoPerfil}
                        placeholder="Celular"
                        style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', background: editandoPerfil ? 'white' : '#f5f5f5', cursor: editandoPerfil ? 'text' : 'not-allowed' }}
                      />
                    </Box>
                    <Box flex={1}>
                      <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Correo:</Typography>
                      <input
                        type="email"
                        value={correo || paciente?.email || ''}
                        onChange={e => setCorreo(e.target.value)}
                        disabled={!editandoPerfil}
                        placeholder="Correo"
                        style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', background: editandoPerfil ? 'white' : '#f5f5f5', cursor: editandoPerfil ? 'text' : 'not-allowed' }}
                      />
                    </Box>
                  </Box>
                  {paciente?.codigo && (
                    <Box display="flex" gap={2}>
                      <Box flex={1}>
                        <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Obra social:</Typography>
                        <Typography level="body-sm" sx={{ color: '#666' }}>
                          {(Array.isArray(mutuales) ? mutuales : []).find(mut => mut.codigo === mutual)?.nombre || paciente?.mutualNombre || '-'}
                        </Typography>
                      </Box>
                      <Box flex={1}>
                        <Typography level="body-xs" sx={{ mb: 0.5, fontWeight: 500 }}>Número de afiliado:</Typography>
                        <Typography level="body-sm" sx={{ color: '#666' }}>{mutualAfiliado || paciente?.mutualAfiliado || '-'}</Typography>
                      </Box>
                    </Box>
                  )}
                  <Box display="flex" gap={2} marginTop={2} flexWrap="wrap" justifyContent="flex-end">
                    {!editandoPerfil ? (
                      <Button 
                        variant="soft" 
                        color="primary" 
                        onClick={handleEditarPerfil} 
                        sx={{ minWidth: '120px' }}
                      >
                        Editar
                      </Button>
                    ) : (
                      <>
                        <Button 
                          variant="outlined" 
                          color="danger" 
                          onClick={handleCancelarEdicionPerfil} 
                          sx={{ minWidth: '120px' }}
                        >
                          Salir
                        </Button>
                        <Button 
                          variant="solid" 
                          color="success" 
                          onClick={handleGuardarPerfil} 
                          sx={{ minWidth: '140px' }} 
                          disabled={error}
                        >
                          Grabar y salir
                        </Button>
                      </>
                    )}
                  </Box>
                </Box>
              </Card>
            </AccordionDetails>
          </Accordion>
        </AccordionGroup>
      </Card>
    </div>
  );
};

export default MisDatos;
